// src/config/config.store.ts

import { create } from 'zustand';
import { getConfig } from '@/config';

type ConfigStore = {
  isDemoUser: boolean; // Determined after login
  downloadLimit: number; // Limit for downloads
  isMswEnabled: Record<string, boolean>; // By domain (auth, users, etc.)
  setDemoUser: (isDemo: boolean) => void;
  setMswFlag: (domain: string, isEnabled: boolean) => void;
};

// We get the initial configuration from getConfig
const config = getConfig();

export const useConfigStore = create<ConfigStore>((set) => ({
  isDemoUser: false, // By default, we asume is not demo
  downloadLimit: config.VITE_DOWNLOAD_LIMIT, // Default value from config
  isMswEnabled: {
    auth: config.VITE_AUTH_IS_MSW,
    user: config.VITE_USER_IS_MSW,
    customer: config.VITE_CUSTOMER_IS_MSW,
    source: config.VITE_SOURCES_IS_MSW,
    functioning: config.VITE_FUNDING_IS_MSW,
  },
  setDemoUser: (isDemo) => set({ isDemoUser: isDemo }),
  setMswFlag: (domain, isEnabled) =>
    set((state) => ({
      isMswEnabled: { ...state.isMswEnabled, [domain]: isEnabled },
    })),
}));
